
/*custom cart notices START*/
/*function deferJQCartCheck(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { deferJQCartCheck(method); }, 50);
    }
}
document.addEventListener("DOMContentLoaded", function () {
    

    deferJQCartCheck(function () {
        document.addEventListener('cart:updated', function(event){
            setTimeout(function() { rewriteCartNotices(); }, 1000);
        });
    
        function rewriteCartNotices(){         
            $('.cart_item_notice').remove();
            $('#mini-cart a:contains("Armor Shield IX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
            $('#mini-cart a:contains("Armor Shield IX MAX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
            //$('#mini-cart a:contains("Mystery Gift")').after( "<p class='cart_item_notice' style='color: gray;margin-top: -5px;margin-bottom: -5px;'>($10-$50 Value)</p>" );
        }
        setTimeout(function() { rewriteCartNotices(); }, 5000);
          
    });

});*/
/*custom cart notices END*/

/*custom cart notices BF25*/
function deferJQCartCheck(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { deferJQCartCheck(method); }, 50);
    }
}
document.addEventListener("DOMContentLoaded", function () {
    

    deferJQCartCheck(function () {
        document.addEventListener('cart:updated', function(event){
            setTimeout(function() { rewriteCartNotices(); }, 1000);
        });
    
        function rewriteCartNotices(){         
            $('.cart_item_notice').remove();
            $('#mini-cart a:contains("2X Armor Shield IX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $40</p></div>" );
            $('#mini-cart a:contains("3X Armor Shield IX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $90</p><p class='cart_item_notice_freebie'>+ FREE PREP SHAMPOO</p></div>" );
            $('#mini-cart a:contains("6X Armor Shield IX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $210</p><p class='cart_item_notice_freebie'>+ FREE PREP SHAMPOO</p><p class='cart_item_notice_freebie'>+ FREE 16OZ LITE SPRAY</p></div>" );
            $('#mini-cart a:contains("2X Armor Shield MAX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $60</p></div>" );
            $('#mini-cart a:contains("3X Armor Shield MAX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $120</p><p class='cart_item_notice_freebie'>+ FREE PREP SHAMPOO</p></div>" );
            $('#mini-cart a:contains("6X Armor Shield MAX - Black Friday")').after( "<div class='cart_item_notices'><p class='cart_item_notice_savings'>SAVINGS: $270</p><p class='cart_item_notice_freebie'>+ FREE PREP SHAMPOO</p><p class='cart_item_notice_freebie'>+ FREE 16OZ LITE SPRAY</p></div>" );
        }
        setTimeout(function() { rewriteCartNotices(); }, 5000);
          
    });

});
/*custom cart notices BF25 END*/

/* rebuy cart auto open failsafe START */
cartOpenPending = false;
smartCartLoaded = false;
document.querySelector("a.header__icon-wrapper[aria-label='Cart']").addEventListener("click", function(event){
  event.preventDefault();
  if(!smartCartLoaded){
    cartOpenPending = true;
  }else{
    cartOpenPending = false;
  }
});
document.addEventListener('rebuy:smartcart.show', function(event){
    cartOpenPending = false;
    smartCartLoaded = true;
});
document.addEventListener('rebuy:smartcart.ready', function(event){
    smartCartLoaded = true;
    if(cartOpenPending){
      cartOpenPending = false;
      Rebuy.SmartCart.show();
    }
});
document.addEventListener('cart:updated', function(event) {
  if(!smartCartLoaded){
    cartOpenPending = true;
  }
});
/* rebuy cart auto open failsafe END */

/*----------CART LOGIC START----------*/
/*
VARIANT ID REFERENCE:
AS9: 39811906994254
MAX: 40287735414862
IPA 8oz: 39884299468878
MF6-pack: 39811908108366
MF3-pack: 39811908173902
WashMitt: 39811906895950
Lite 16oz: 39909690376270
Lite 8oz: 39909690409038
Psycho: 40424477229134
Psycho PRO: 40424474738766
RimReaper: 40424481849422
SadisticSuds: 40424482897998
ShockWave: 40424486010958
Wrathene: 40424478965838
AS9dup: 41428889501774
MAXdup: 41429201420366
AS9dupNB: 41751062184014
MaintenanceShampoo: 39992219598926
*/

freebiePool = {
  /*"mg_asl": {
      productVariantId: "42565516197966",
      weight: 2
  },
  "mg_wm": {
      productVariantId: "42566584860750",
      weight: 6
  },
  "mg_ms": {
      productVariantId: "42564535386190",
      weight: 4
  }*/
}


cartPromotions = {
  /*"cart_campaign_pool": {
      conditionProductVariantId: "39811906994254",//AS9
      conditionProductQuantity: 2,
      freebieProductVariantId: "",
      freebieProductQuantity: 1,
      freebieLimited: true
  }*/
  "vinwikilite": {
      conditionProductVariantId: "42591692030030",//AS9vinwiki
      conditionProductQuantity: 1,
      freebieProductVariantId: "39909690376270",//Lite 16oz
      freebieProductQuantity: 1,
      freebieLimited: true
  },
  "maxDupFreeSuds": {
      conditionProductVariantId: "42708792213582",//MAXdup
      conditionProductQuantity: 1,
      freebieProductVariantId: "40424482897998",//SadisticSuds
      freebieProductQuantity: 1,
      freebieLimited: true
  },
  "lsclite": {
      conditionProductVariantId: "42265168707662",//AS9lsc
      conditionProductQuantity: 2,
      freebieProductVariantId: "39909690376270",//Lite 16oz
      freebieProductQuantity: 1,
      freebieLimited: true
  },
  "lscvip": {
      conditionProductVariantId: "42751341264974",//AS9lsc VIP
      conditionProductQuantity: 1,
      freebieProductVariantId: "40424482897998",//SadisticSuds
      freebieProductQuantity: 1,
      freebieLimited: true
  }/*,
  "maxwrath": {
      conditionProductVariantId: "40287735414862",//MAX
      conditionProductQuantity: 1,
      freebieProductVariantId: "40424478965838",//Wrathene
      freebieProductQuantity: 1,
      freebieLimited: true
  }*/
}
document.addEventListener('cart:updated', function(event){
  checkCartForCodeFreebie(event);
});

function checkCartForCodeFreebie(event){
  $.getJSON('/cart.js', function(cart) {
    var cartItems = cart.items;
    var masterFreebieUpdateArray = [];

    for (const key in cartPromotions) {
      cartPromotion = cartPromotions[key];
      if(key == "cart_campaign_pool"){
        //freebie pool campaign
        checkVariantID = cartPromotion.conditionProductVariantId;
        //checkFreebieID = cartPromotion.freebieProductVariantId;
        filteredCartItems = cartItems.filter(e => e.variant_id == checkVariantID &&  !e.properties._cart_campaign);//don't allow freebies to factor as condition products
        filteredCartFreebieItems = cartItems.filter(e => e.properties._cart_campaign == "cart_campaign_pool");//get all that match the campaign

        //determine freebie level
        freebieQuantitySet = 0;
        if (filteredCartItems.length > 0) {
          //condition product in cart
          checkProductQuantity = filteredCartItems[0].quantity;

          if(checkProductQuantity >= cartPromotion.conditionProductQuantity){
            //quantity and other conditions met
            if(cartPromotion.freebieLimited){
              freebieQuantitySet = cartPromotion.freebieProductQuantity;
            }else{
              freebieQuantitySet = Math.floor(checkProductQuantity / cartPromotion.conditionProductQuantity * cartPromotion.freebieProductQuantity);
            }

            //pick freebie
            //construct freebies array
            var freebiesArray = [];
            for (const key in freebiePool) {
              freebie  = freebiePool[key];
              for (var i = 0; i < freebie.weight; i++) freebiesArray.push(freebie.productVariantId);
            }
            //pick random
            randomFreebie = freebiesArray[Math.floor(Math.random() * freebiesArray.length)];
            masterFreebieUpdateArray[randomFreebie] = masterFreebieUpdateArray[randomFreebie] + freebieQuantitySet;
          }
        }

        //check if current in cart matches freebie level
        if(filteredCartFreebieItems[0]){
          //freebie is already in cart, update quantity if needed
          if(filteredCartFreebieItems[0].quantity != freebieQuantitySet){
            let formData = {
              'id': filteredCartFreebieItems[0].key,
              'quantity': freebieQuantitySet
            };
            
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              //refresh cart
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    'cart': cart
                }
              }));
              document.getElementById('mini-cart').open = true;
              setTimeout(function() {
                deferJQCartCheck(function () {               
                    function rewriteCartNotices2(){         
                        $('.cart_item_notice').remove();
                        $('#mini-cart a:contains("Armor Shield IX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                        $('#mini-cart a:contains("Armor Shield IX MAX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                        $('#mini-cart a:contains("Mystery Gift")').after( "<p class='cart_item_notice' style='color: gray;margin-top: -5px;margin-bottom: -5px;'>($10-$50 Value)</p>" );
                    }
                    setTimeout(function() { rewriteCartNotices2(); }, 500);
                      
                });
              }, 2000);
              //refresh cart end
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        }else if(freebieQuantitySet > 0){
          //add the freebie to cart
          let formData = {
            'items': [{
            'id': randomFreebie,
            'quantity': freebieQuantitySet,
              properties: {
                '_cart_campaign': key,
                '_dynamicfreebie': true,
              }
            }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            //refresh cart
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    'cart': cart
                }
            }));
            document.getElementById('mini-cart').open = true;
            setTimeout(function() {
              deferJQCartCheck(function () {               
                  function rewriteCartNotices2(){         
                      $('.cart_item_notice').remove();
                      $('#mini-cart a:contains("Armor Shield IX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                      $('#mini-cart a:contains("Armor Shield IX MAX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                      $('#mini-cart a:contains("Mystery Gift")').after( "<p class='cart_item_notice' style='color: gray;margin-top: -5px;margin-bottom: -5px;'>($10-$50 Value)</p>" );
                  }
                  setTimeout(function() { rewriteCartNotices2(); }, 500);
                    
              });
            }, 2000);
            //refresh cart end
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }

      }else{
        //normal campaign
        console.log("normal campaign");
        //cartPromotion  = cartPromotions[key];
        checkVariantID = cartPromotion.conditionProductVariantId;
        checkFreebieID = cartPromotion.freebieProductVariantId;
        filteredCartItems = cartItems.filter(e => e.variant_id == checkVariantID &&  !e.properties._cart_campaign);//don't allow freebies to factor as condition products
        filteredCartFreebieItems = cartItems.filter(e => e.variant_id == checkFreebieID  &&  e.properties._cart_campaign == key);

        //determine freebie level
        freebieQuantitySet = 0;
        if (filteredCartItems.length > 0) {
          //condition product in cart
          checkProductQuantity = filteredCartItems[0].quantity;

          if(checkProductQuantity >= cartPromotion.conditionProductQuantity){
            //quantity and other conditions met
            if(cartPromotion.freebieLimited){
              freebieQuantitySet = cartPromotion.freebieProductQuantity;
            }else{
              freebieQuantitySet = Math.floor(checkProductQuantity / cartPromotion.conditionProductQuantity * cartPromotion.freebieProductQuantity);
            }
            masterFreebieUpdateArray[checkFreebieID] = masterFreebieUpdateArray[checkFreebieID] + freebieQuantitySet;
          }
        }

        //check if current in cart matches freebie level
        if(filteredCartFreebieItems[0]){
          //freebie is already in cart, update quantity if needed
          if(filteredCartFreebieItems[0].quantity != freebieQuantitySet){
            let formData = {
              'id': filteredCartFreebieItems[0].key,
              'quantity': freebieQuantitySet
            };
            
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              //refresh cart
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    'cart': cart
                }
              }));
              document.getElementById('mini-cart').open = true;
              setTimeout(function() {
                deferJQCartCheck(function () {               
                    function rewriteCartNotices2(){         
                        $('.cart_item_notice').remove();
                        $('#mini-cart a:contains("Armor Shield IX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                        $('#mini-cart a:contains("Armor Shield IX MAX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                        $('#mini-cart a:contains("Mystery Gift")').after( "<p class='cart_item_notice' style='color: gray;margin-top: -5px;margin-bottom: -5px;'>($10-$50 Value)</p>" );
                    }
                    setTimeout(function() { rewriteCartNotices2(); }, 500);
                      
                });
              }, 2000);
              //refresh cart end
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        }else if(freebieQuantitySet > 0){
          //add the freebie to cart
          let formData = {
            'items': [{
            'id': checkFreebieID,
            'quantity': freebieQuantitySet,
              properties: {
                '_cart_campaign': key,
                '_dynamicfreebie': true,
              }
            }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            //refresh cart
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    'cart': cart
                }
            }));
            document.getElementById('mini-cart').open = true;
            setTimeout(function() {
              deferJQCartCheck(function () {               
                  function rewriteCartNotices2(){         
                      $('.cart_item_notice').remove();
                      $('#mini-cart a:contains("Armor Shield IX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                      $('#mini-cart a:contains("Armor Shield IX MAX DIY Ceramic Coating Kit")').after( "<p class='cart_item_notice'>EXCEPTIONAL ORDER VOLUME: ships out from June 4th.</p>" );
                      $('#mini-cart a:contains("Mystery Gift")').after( "<p class='cart_item_notice' style='color: gray;margin-top: -5px;margin-bottom: -5px;'>($10-$50 Value)</p>" );
                  }
                  setTimeout(function() { rewriteCartNotices2(); }, 500);
                    
              });
            }, 2000);
            //refresh cart end
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      }

      
      

    }//end for loop through cartPromotions

  });
}
/*----------CART LOGIC END----------*/

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */